import React from 'react';
import PropTypes from 'prop-types';
import { useRoute } from '@app/router';
import * as AREAS from '../constants/functionalAreas';
import * as LEVELS from '../constants/permissionLevels';
import * as NUTZERGRUPPEN from '../constants/nutzergruppen';
import Navbar from './Navbar';
import NavbarDropdown from './NavbarDropdown';
import NavItemFactory from './NavItem';
import AreaAwareItem from './AreaAwareItem';
import NavDividerFactory from './NavDivider';
import { checkAccess, betriebsauswahlAktiv, istGenossenschaft, hasBetrieb } from '../helpers/menuHelpers';
var isWbrOver = function () { return ((new Date('2023-01-01T00:00:00')) < (new Date())); };
var DropdownBetrieb = function (_a) {
    var user = _a.user;
    var NavItem = NavItemFactory(user);
    var NavDivider = NavDividerFactory(user);
    if (!(checkAccess(user, AREAS.FUNCTIONAL_AREA_STANDARD)
        || checkAccess(user, AREAS.FUNCTIONAL_AREA_DOWNLOAD_BENUTZER)
        || checkAccess(user, AREAS.FUNCTIONAL_AREA_BENUTZERDATEN)
        || checkAccess(user, AREAS.FUNCTIONAL_AREA_NUTZUNGSPROTOKOLL))) {
        return null;
    }
    return (React.createElement(NavbarDropdown, { name: "navbar-betrieb", label: "Betrieb/Benutzer" },
        hasBetrieb(user)
            && (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_DOWNLOAD_BETRIEB, href: "/betrieb/download" }, "Betriebsdownloads")),
        hasBetrieb(user)
            && (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_STAMMDATEN_BETRIEB, href: "/betrieb/stammdaten" }, "Betriebsdaten")),
        betriebsauswahlAktiv(user)
            && (React.createElement(NavItem, { href: "/user/betriebsauswahl" }, "Betriebsauswahl")),
        React.createElement(NavDivider, null),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_DOWNLOAD_BENUTZER, href: "/user/download" }, "Benutzerdownloads"),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_BENUTZERDATEN, href: "/user/benutzerdaten" }, "Benutzerdaten"),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_NUTZUNGSPROTOKOLL, href: "/user/nutzungsprotokoll" }, "Nutzungsprotokoll"),
        hasBetrieb(user) ? React.createElement(NavItem, { href: "/user/berechtigungen" }, "Berechtigungen") : ''));
};
var DropdownWeinbaukartei = function (_a) {
    var user = _a.user, betrieb = _a.betrieb;
    var ROUTE = useRoute();
    var NavItem = NavItemFactory(user);
    var NavDivider = NavDividerFactory(user);
    if (!hasBetrieb(user)
        || !user.hasOwnProperty('nutzergruppe')
        || user.nutzergruppe === NUTZERGRUPPEN.GROUP_EXTERN
        || !(checkAccess(user, AREAS.FUNCTIONAL_AREA_REBFLAECHEN) || checkAccess(user, AREAS.FUNCTIONAL_AREA_WEINERZEUGUNG) || checkAccess(user, AREAS.FUNCTIONAL_AREA_HEKTARERTRAGSREGELUNG))) {
        return null;
    }
    return (React.createElement(NavbarDropdown, { name: "navbar-wbk", label: "Weinbaukartei" },
        (istGenossenschaft(user))
            ? (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN, to: ROUTE.PAGE.REBFLAECHEN.EZZ_AUSWAHL({ betrieb_nr: betrieb }) }, "Rebfl\u00E4chen"))
            : (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN, to: ROUTE.PAGE.REBFLAECHEN.REBFLAECHEN_INDEX({ betrieb_nr: betrieb }) }, "Rebfl\u00E4chen mit \u00C4nderungsmeldung")),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN, to: istGenossenschaft(user)
                ? ROUTE.PAGE.REBFLAECHEN.EZZ_AUSWAHL_VORJAHR({ betrieb_nr: betrieb })
                : ROUTE.PAGE.REBFLAECHEN.REBFLAECHEN_VORJAHR({ betrieb_nr: betrieb }) }, "Rebfl\u00E4chen - Vorjahr"),
        !isWbrOver()
            && (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN, href: "/wbr/wbr/index" }, "Wiederbepflanzungsrechte (WBR)")),
        !istGenossenschaft(user)
            && (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN, level: LEVELS.PERMISSION_LEVEL_WRITE_ACCESS, href: "/wbr/gru/uebersicht" }, "Umwandlungsantrag (WBR)")),
        !istGenossenschaft(user)
            && (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN, level: LEVELS.PERMISSION_LEVEL_WRITE_ACCESS, href: "/wbr/grw/uebersicht" }, "Antrag auf Wiederbepflanzung")),
        !istGenossenschaft(user)
            && (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN, level: LEVELS.PERMISSION_LEVEL_READ_ACCESS, to: ROUTE.PAGE.PFLANZGENEHMIGUNGEN.INDEX({ betrieb_nr: betrieb }) }, "Pflanzgenehmigungen")),
        React.createElement(NavDivider, { user: user, area: AREAS.FUNCTIONAL_AREA_HEKTARERTRAGSREGELUNG }),
        React.createElement(NavItem, { to: !istGenossenschaft(user)
                ? ROUTE.PAGE.VERMARKTUNGSRECHTE.UEBERSICHT({ betrieb_nr: betrieb })
                : ROUTE.PAGE.VERMARKTUNGSRECHTE.ERZEUGERAUSWAHL({ betrieb_nr: betrieb }), area: AREAS.FUNCTIONAL_AREA_HEKTARERTRAGSREGELUNG }, "Vermarktungsrechte / GHE-Meldung"),
        React.createElement(NavDivider, { user: user, area: AREAS.FUNCTIONAL_AREA_WEINERZEUGUNG, level: LEVELS.PERMISSION_LEVEL_WRITE_ACCESS }),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_WEINERZEUGUNG, level: LEVELS.PERMISSION_LEVEL_WRITE_ACCESS, href: "/bestandsmeldung/index" }, "Bestandsmeldung"),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_WEINERZEUGUNG, level: LEVELS.PERMISSION_LEVEL_WRITE_ACCESS, href: "/tem/index" }, "Traubenerntemeldung"),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_WEINERZEUGUNG, level: LEVELS.PERMISSION_LEVEL_WRITE_ACCESS, href: "/lv/index" }, "Lieferantenverzeichnis"),
        React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_WEINERZEUGUNG, level: LEVELS.PERMISSION_LEVEL_WRITE_ACCESS, href: "/wem/index" }, "Weinerzeugungsmeldung")));
};
var UserNavigation = function (_a) {
    var user = _a.user, betrieb = _a.betrieb;
    var ROUTE = useRoute();
    var NavItem = NavItemFactory(user);
    var NavDivider = NavDividerFactory(user);
    var appContainer = document.getElementById('app');
    var showNewEilverfahren = appContainer !== null
        && !!appContainer.getAttribute('data-feature-flag-qp');
    return (React.createElement(Navbar, { name: "navbar", containerFluid: false, className: "navbar-inverse navbar" },
        React.createElement(NavItem, { href: "/" }, "Startseite"),
        React.createElement(DropdownBetrieb, { user: user }),
        React.createElement(DropdownWeinbaukartei, { user: user, betrieb: betrieb }),
        (hasBetrieb(user)
            && user.hasOwnProperty('nutzergruppe')
            && !istGenossenschaft(user)
            && user.nutzergruppe !== NUTZERGRUPPEN.GROUP_EXTERN
            && checkAccess(user, AREAS.FUNCTIONAL_AREA_REBFLAECHEN, LEVELS.PERMISSION_LEVEL_WRITE_ACCESS))
            && (React.createElement(NavbarDropdown, { name: "navbar-foerderung", label: "F\u00F6rderung" },
                React.createElement(NavItem, { to: ROUTE.PAGE.UMSTRUKTURIERUNGSANTRAG.TEIL_1({ betrieb_nr: betrieb }) }, "Umstrukturierungsantrag - Teil 1"),
                React.createElement(NavItem, { to: ROUTE.PAGE.UMSTRUKTURIERUNGSANTRAG.TEIL_2({ betrieb_nr: betrieb }) }, "Umstrukturierungsantrag - Teil 2"),
                React.createElement(NavItem, { to: ROUTE.PAGE.FERTIGSTELLUNGSMELDUNG.LOGIN({ betrieb_nr: betrieb }) }, "Umstrukturierungsantrag - Fertigstellungsmeldung"),
                React.createElement(NavDivider, { user: user, area: AREAS.FUNCTIONAL_AREA_REBFLAECHEN }),
                React.createElement(NavItem, { href: "/site/auszugKrisenhilfeFrost" }, "Auszug Krisenhilfe Frost"))),
        user.hasOwnProperty('nutzergruppe')
            && user.nutzergruppe === NUTZERGRUPPEN.GROUP_EXTERN
            && (React.createElement(NavItem, { area: AREAS.FUNCTIONAL_AREA_NUTZUNGSARTEN, to: ROUTE.PAGE.NUTZUNGSARTEN.INDEX() }, "Nutzungsarten")),
        hasBetrieb(user)
            && (React.createElement(AreaAwareItem, { user: user, area: AREAS.FUNCTIONAL_AREA_QUALITAET },
                React.createElement(NavbarDropdown, { name: "navbar-qualitaetspruefung", label: "Qualit\u00E4tspr\u00FCfung" },
                    React.createElement(NavItem, { href: "/qp" }, "Antr\u00E4ge"),
                    React.createElement(NavItem, { href: "/landespraemierung/index" }, "Pr\u00E4mierungszertifikate")))),
        (hasBetrieb(user) || user.nutzergruppe === NUTZERGRUPPEN.GROUP_ADMIN)
            && React.createElement(NavItem, { to: ROUTE.PAGE.WIPZN.INDEX(), target: "_blank" }, "WIPZN"),
        React.createElement(NavbarDropdown, { name: "navbar-service", label: "Service" },
            React.createElement(NavItem, { to: ROUTE.PAGE.COMMON.FAQ() }, "FAQ"),
            React.createElement(NavItem, { to: ROUTE.PAGE.COMMON.FACTS() }, "Wissenswertes"),
            React.createElement(NavItem, { to: ROUTE.PAGE.COMMON.REQUIREMENTS() }, "Systemvoraussetzungen"),
            React.createElement(NavItem, { to: ROUTE.PAGE.COMMON.FORMS() }, "Formulare"),
            React.createElement(NavItem, { to: ROUTE.PAGE.COMMON.EMAIL_LWK() }, "Kontakt"))));
};
UserNavigation.propTypes = {
    user: PropTypes.object.isRequired,
    betrieb: PropTypes.string,
};
export default UserNavigation;
